import { Component, Element } from '@stencil/core';

@Component({
  tag: 'uvex-gallery-starter',
})
export class GalleryStarter {
  @Element() el!: HTMLElement;

  componentDidLoad() {
    Array.from(this.el.querySelectorAll('picture')).forEach(element => element.addEventListener('click', (event: MouseEvent) => this.onClick(event)));
  }

  onClick(event: MouseEvent) {
    event.preventDefault();
    const galleryElement = document.createElement('uvex-gallery');
    galleryElement.setAttribute('galleryElement', '0');
    Array.from(this.el.querySelectorAll('picture'))
      .map(el => el.getAttribute('data-gallery'))
      .map(image => {
        const imageElement = document.createElement('uvex-gallery-image');
        return Object.assign(imageElement, {
          image: image,
          active: true,
          transition: true,
        });
      })
      .forEach(imageElement => galleryElement.appendChild(imageElement));

    const modalElement = document.createElement('uvex-gallery-modal');
    modalElement.appendChild(galleryElement);
    Object.assign(modalElement, {
      content: galleryElement,
    });
    document.body.appendChild(modalElement);
  }
}
